"use strict";

var _slicedToArray = require("/home/runner/work/react-nexys-boilerplate/react-nexys-boilerplate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WithLoader = exports.UI = void 0;

var react_1 = __importDefault(require("react"));

var load_1 = require("../../../data/load");

var buttons_group_1 = __importDefault(require("./buttons-group"));

var Loader = function Loader(props) {
  var isLoading = props.isLoading;

  if (isLoading !== true) {
    return null;
  }

  return react_1.default.createElement("p", null, react_1.default.createElement("i", null, "The status is being updated, please wait"));
};

var StatusUI = function StatusUI(props) {
  var id = props.id,
      updatePromise = props.updatePromise,
      options = props.options;

  var _react_1$default$useS = react_1.default.useState(props.selectedId),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      selectedId = _react_1$default$useS2[0],
      setSelectedId = _react_1$default$useS2[1];

  var _react_1$default$useS3 = react_1.default.useState(false),
      _react_1$default$useS4 = _slicedToArray(_react_1$default$useS3, 2),
      isLoading = _react_1$default$useS4[0],
      setIsLoading = _react_1$default$useS4[1];

  var handleClick = function handleClick(optionId) {
    setIsLoading(true);
    updatePromise(id, optionId).then(function (_) {
      setSelectedId(optionId);
      setIsLoading(false);
    });
  };

  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(buttons_group_1.default, {
    options: options,
    selectedId: selectedId,
    onClick: handleClick
  }), react_1.default.createElement(Loader, {
    isLoading: isLoading
  }));
};

exports.UI = function (props) {
  var data = props.data,
      updatePromise = props.updatePromise;
  var options = data.options,
      selectedId = data.selectedId,
      id = data.id;
  return react_1.default.createElement(StatusUI, {
    id: id,
    options: options,
    selectedId: selectedId,
    updatePromise: updatePromise
  });
};

exports.WithLoader = function (props) {
  var dataLoad = props.dataLoad,
      updatePromise = props.updatePromise,
      rest = __rest(props, ["dataLoad", "updatePromise"]);

  return react_1.default.createElement(load_1.WithLoader, Object.assign({
    Component: exports.UI,
    dataLoad: dataLoad,
    updatePromise: updatePromise
  }, rest));
};